"use client";

export { AudioCreationWorkspace as AudioGenerationFlow } from "@/components/audio/AudioCreationWorkspace";
